import { Stack, Typography, Button, MenuItem, Select } from "@mui/material"
import { colours } from "../../StyleConstants"
import StepperDUC from "../duc/StepperDUC"
import { DownloadProcessSteps, stepLabels } from "./DataDownloadProcess"
import Selector from "./components/Selector"

const DownloadFull = (props: any) => {
    const handleClickBack = () => {
        props.setCurStep(DownloadProcessSteps.DatasetSelection)
    }

    return (
        <Stack gap={3} sx={{ padding: 3 }}>
            <Stack flexDirection="column" gap={4} alignItems="center">
                <Typography
                    variant="h3"
                    fontWeight="600"
                    fontSize="40px"
                    textAlign="center"
                    color={colours.midnightBlue.blue}>
                    New Dataset Download
                </Typography>
                <StepperDUC
                    activeStep={DownloadProcessSteps.DownloadDetails}
                    stepLabels={stepLabels}
                />
            </Stack>

            <Button
                variant="tertiary"
                onClick={() => handleClickBack()}
                sx={{ width: "150px" }}
            >
                Back
            </Button>

            <Stack direction="row" gap={3} sx={{ marginTop: 3 }}>
                <Stack flex={1}>
                    <Typography variant="h6" fontWeight="600" color={colours.orange.orange}>
                        Selected study
                    </Typography>
                    <Selector
                        title={props.info.study}
                        hover={false}
                        text="Information about the study"/>
                </Stack>

                <Stack flex={1}>
                    <Typography variant="h6" fontWeight="600" color={colours.orange.orange}>
                        Selected release
                    </Typography>
                    <Selector
                        title={props.info.release}
                        hover={false}
                        text="Information about the study"/>
                </Stack>

                <Stack flex={1}>
                    <Typography variant="h6" fontWeight="600" color={colours.orange.orange}>
                        Selected dataset
                    </Typography>
                    <Selector
                        title={props.info.release.split("-")[0] + "Full Dataset"}
                        hover={false}
                        text="Information about the study"/>
                </Stack>
            </Stack>
            
            <Stack alignItems="center" sx={{ marginTop: 3 }} gap={2}>
                <Stack direction="row" gap={2} alignItems="center">
                    <Select defaultValue="selected-destination" sx={{ width: '200px' }}>
                        <MenuItem value="selected-destination">Selected destination</MenuItem>
                    </Select>
                    <Button variant="tertiary">
                            New Destination
                    </Button>
                </Stack>

                <Button
                    variant="primary"
                    disabled={true}
                >
                        Download
                </Button>
            </Stack>
        </Stack>
            
    )
}

export default DownloadFull